import React, { Component } from 'react';
// import {Redirect} from 'react-router-dom';
import Routes from './routes';

class App extends Component {
  constructor() {
    super();
    this.state = {
      appName: "TLC",
    }
  }

  render() {
    return (
        <Routes name={this.state.appName} />
    );
  }
}

export default App;
